import { motion } from "framer-motion";
import { PROCESS } from "@/data/content";

export const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="relative py-24 sm:py-32 border-t border-line">
      <div className="container-x">
        <div className="max-w-2xl mb-16">
          <span className="mono-label text-accent">[ How we work ]</span>
          <h2 className="font-head font-black tracking-tighter text-4xl sm:text-5xl lg:text-6xl mt-4 text-balance">
            A clear path from idea to revenue.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-px bg-line border border-line">
          {PROCESS.map((p, i) => (
            <motion.div
              key={p.num}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              data-testid={`process-step-${i}`}
              className="group bg-surface p-8 lg:p-10 hover:bg-surface-2 transition-colors"
            >
              <div className="font-head font-black text-5xl text-line group-hover:text-accent transition-colors">
                {p.num}
              </div>
              <h3 className="font-head font-bold text-xl mt-6 mb-2">{p.title}</h3>
              <p className="text-text-2 text-sm leading-relaxed">{p.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
